import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { ToastsManager } from 'ng2-toastr';
import { Toastr } from '../utilities/toastr.component';
import { GeneralService } from './general.service';

@Injectable()
export class ErrorHandlerService {
  constructor(private GS: GeneralService, private router: Router) {}

  checkAndShowpageError(errorCode: string, page: any) {
    if (errorCode == 'E204') {
      this.GS.sendNote({
        text: 'Due to inactivity, you will be logged out of the portal soon',
        duration: 10000,
        type: 'danger',
      });
      setTimeout(() => {
        this.router.navigate(['/auth/login']);
      }, 5000);
    }
  }
}
